const icons = [
	{
		url: 'https://img.icons8.com/?size=100&id=QXTadxb24bUa&format=png&color=000000',
		title: 'Nómina',
	},
	{
		url: 'https://img.icons8.com/?size=100&id=2s0NBaucNEOt&format=png&color=000000',
		title: 'Catálogos',
	},
	{
		url: 'https://img.icons8.com/?size=100&id=lMhEFosNBRbT&format=png&color=000000',
		title: 'Compras',
	},
	{
		url: 'https://img.icons8.com/?size=100&id=aUiThmwNs5sO&format=png&color=000000',
		title: 'Ventas',
	},
	{
		url: 'https://img.icons8.com/?size=100&id=sH5IBgX3H7wP&format=png&color=000000',
		title: 'Transporte de Mercancía',
	},
	{
		url: 'https://img.icons8.com/?size=100&id=sH5IBgX3H7wP&format=png&color=000000',
		title: 'T. Mercancía',
	},
	{
		url: 'https://img.icons8.com/?size=100&id=0JF1WhA0SvTr&format=png&color=000000',
		title: 'Facturación USA',
	},
	{
		url: 'https://img.icons8.com/?size=100&id=3Qj1WJsYS8T4&format=png&color=000000',
		title: 'Gastos',
	},
	{
		url: 'https://img.icons8.com/?size=100&id=R07znxp6MgI0&format=png&color=000000',
		title: 'Transporte de Personal',
	},
	{
		url: 'https://img.icons8.com/?size=100&id=R07znxp6MgI0&format=png&color=000000',
		title: 'T. Personal',
	},
	{
		url: 'https://img.icons8.com/?size=100&id=pt5RU2ksbVFL&format=png&color=000000',
		title: 'Tráfico',
	},
	{
		url: 'https://img.icons8.com/?size=100&id=C7Lw7qnOCN0M&format=png&color=000000',
		title: 'Llantas',
	},
	{
		url: 'https://img.icons8.com/?size=100&id=93a3SInn9e4L&format=png&color=000000',
		title: 'Suministro',
	},
	{
		url: 'https://img.icons8.com/?size=100&id=N5JNmydXBuCl&format=png&color=000000',
		title: 'Configuración',
	},
	{
		url: 'https://img.icons8.com/?size=100&id=wl02Vd5WH3QG&format=png&color=000000',
		title: 'Documentos',
	},
	{
		url: 'https://img.icons8.com/?size=100&id=jSUovXK3tTSQ&format=png&color=000000',
		title: 'Almacén',
	},
	{
		url: 'https://img.icons8.com/?size=100&id=DAoPjn2XoTUN&format=png&color=000000',
		title: 'Dashboard',
	},
	{
		url: 'https://img.icons8.com/?size=100&id=8mCUJDxYMgja&format=png&color=000000',
		title: 'Modelado de procesos',
	},
	{
		url: 'https://img.icons8.com/?size=100&id=8mCUJDxYMgja&format=png&color=000000',
		title: 'Modelado',
	},
	{
		url: 'https://img.icons8.com/?size=100&id=tfhR4Jc1PDQ7&format=png&color=000000',
		title: 'Bancos y Contabilidad',
	},
	{
		url: 'https://img.icons8.com/?size=100&id=tfhR4Jc1PDQ7&format=png&color=000000',
		title: 'Bancos',
	},
	{
		url: 'https://img.icons8.com/?size=100&id=wCClDpWTvma9&format=png&color=000000',
		title: 'Contabilidad',
	},
	{
		url: 'https://img.icons8.com/?size=100&id=HMwxzLul2dfm&format=png&color=000000',
		title: 'Taller',
	},
	{
		url: 'https://img.icons8.com/?size=100&id=LcVQQn9beLrS&format=png&color=000000',
		title: 'Activos',
	},
	{
		url: 'https://img.icons8.com/?size=100&id=MApf6KZ9NYzO&format=png&color=000000',
		title: 'Caseta',
	},
	{
		url: 'https://img.icons8.com/?size=100&id=94bZrF6ZIaXP&format=png&color=000000',
		title: 'Prospectos',
	},
	{
		url: 'https://img.icons8.com/?size=100&id=s4MzQ849Sdas&format=png&color=000000',
		title: 'Inspección',
	},
	{
		url: 'https://img.icons8.com/?size=100&id=MexKOWjN2DR1&format=png&color=000000',
		title: 'Incidencias',
	},
	{
		url: 'https://img.icons8.com/?size=100&id=wG20FqoYHvVB&format=png&color=000000',
		title: 'Gestión de Tareas Internas',
	},
	{
		url: 'https://img.icons8.com/?size=100&id=wG20FqoYHvVB&format=png&color=000000',
		title: 'Tareas Internas',
	},
	{
		url: 'https://img.icons8.com/?size=100&id=8cWmD9lajgRn&format=png&color=000000',
		title: 'Sellos',
	},
	{
		url: 'https://img.icons8.com/?size=100&id=bwUgs69v7bOd&format=png&color=000000',
		title: 'Reportes',
	},
	{
		url: 'https://img.icons8.com/?size=100&id=ZWJCMSKtvjqn&format=png&color=000000',
		title: 'Presupuesto',
	},
	{
		url: 'https://img.icons8.com/?size=100&id=vNKQXcyeaWkL&format=png&color=000000',
		title: 'Mantenimientos',
	},
	{
		url: 'https://img.icons8.com/?size=100&id=wG20FqoYHvVB&format=png&color=000000',
		title: 'Entidades',
	},
	{
		url: 'https://img.icons8.com/?size=100&id=kgfo8W3bFDUx&format=png&color=000000',
		title: 'Formularios',
	},
	{
		url: 'https://img.icons8.com/?size=100&id=93a3SInn9e4L&format=png&color=000000',
		title: 'Suministros',
	},
	{
		url: 'https://img.icons8.com/?size=100&id=SHX6ze96JczQ&format=png&color=000000',
		title: 'Clientes'
	},
	{
		url: 'https://img.icons8.com/?size=100&id=M9iaNrWtUROf&format=png&color=000000',
		title: 'SuperAdmin'
	},
	{
		url: 'https://img.icons8.com/?size=100&id=fvKS3AKw1AyE&format=png&color=000000',
		title: 'Opciones'
	},
	{
		url: 'https://img.icons8.com/?size=100&id=8RVBL7Oh8H7I&format=png&color=000000',
		title: 'ConfiguracionUser'
	},
	{
		url: 'https://img.icons8.com/?size=100&id=uVA8I3rgWfOs&format=png&color=000000',
		title: 'LogOutUser'
	},
	{
		url: 'https://img.icons8.com/?size=100&id=7LhMaNDFgoYK&format=png&color=000000',
		title: 'NotasUser'
	},
]

export default icons
